import {
  Flex,
  TextInput,
  ActionIcon,
  Group,
  Loader,
  NumberFormatter,
  Select,
  Text,
  SegmentedControl,
} from "@mantine/core";
import { IconSearch, IconLayoutGrid, IconList } from "@tabler/icons-react";
import { actions, useTrackedStore } from "../../../../store/useStore";
import { useGetAllAmbassadors } from "../../../../api/ambassador/useAmbassador";
import { IconNextIcon, IconPrevIcon } from "../../static/icons/Icons";
import "./index.css";
import { useRef } from "react";

export const AmbassadorHeader = ({
  details,
  tabsInfo,
}: {
  details?: any;
  tabsInfo?: any;
}) => {
  const {
    filter: { data: filterData },
    ambassadors: { page, pageSize, search, mode },
  } = useTrackedStore();

  const _mode = mode();
  const _pageSize = pageSize();
  const _page = page();
  const _search = search();
  const filters = filterData();

  const {
    data: ambassadors,
    refetch: refetchAmbassadors,
    isFetching: isFetchingList,
  } = useGetAllAmbassadors({
    per_page: _pageSize,
    page: _page,
    params: {
      ...filters,
      country_id: filters?.country_id,
      state_id: filters?.state_id,
      city_id: filters?.city_id,
      search: _search,
    },
  });

  const searchRef = useRef<HTMLInputElement>(null);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const value = searchRef.current?.value || "";
    actions.ambassadors.setSearch(value);
    actions.ambassadors.setPage(1);
    refetchAmbassadors();
  };

  return (
    <Flex
      mb={10}
      mt={"md"}
      align={"center"}
      justify="space-between"
      wrap="wrap"
      gap="md"
    >
      <Flex align={"center"} gap="md" className="number_input" wrap="wrap">
        <Select
          id="change-perPage-button"
          w={80}
          data={["15", "25", "50", "100"]}
          value={String(_pageSize)}
          onChange={(value: any) =>
            actions.ambassadors.setPageSize(value as 25 | 50 | 100)
          }
          searchable={false}
        />
        <Text c="#5F6368" fz={14}>
          Showing ambassadors{" "}
          {isFetchingList ? (
            <Loader my="auto" mx={4} size={12} />
          ) : (
            <NumberFormatter
              thousandSeparator
              value={
                ambassadors?.metaInfo?.totalRecords == 0
                  ? 0
                  : ambassadors?.metaInfo?.perPage *
                      (ambassadors?.metaInfo?.page - 1) +
                    1
              }
            />
          )}
          {" to "}
          {isFetchingList ? (
            <Loader my="auto" mx={4} size={12} />
          ) : (
            <NumberFormatter
              thousandSeparator
              value={ambassadors?.metaInfo?.pageEndOffset}
            />
          )}{" "}
          of{" "}
          <NumberFormatter
            thousandSeparator
            value={ambassadors?.metaInfo?.totalRecords}
          />
        </Text>
      </Flex>
      <Flex justify="center" align="center">
        <Group>
          <ActionIcon
            id="previous-page-button"
            size="xs"
            variant="transparent"
            disabled={!ambassadors?.metaInfo?.hasPreviousPage}
            onClick={() => actions.ambassadors.setPrevPage()}
          >
            <IconPrevIcon
              color={
                ambassadors?.metaInfo?.hasPreviousPage ? "#1A73E8" : "#5F6368"
              }
              opacity={ambassadors?.metaInfo?.hasPreviousPage ? 1 : 0.5}
            />
          </ActionIcon>
          <Text fz={14}>
            Page {_page} of{" "}
            <span style={{ color: "#5F6368" }}>
              {ambassadors?.metaInfo?.lastPage}
            </span>
          </Text>
          <ActionIcon
            id="next-page-button"
            size="xs"
            variant="transparent"
            disabled={!ambassadors?.metaInfo?.hasNextPage}
            onClick={() => actions.ambassadors.setNextPage()}
          >
            <IconNextIcon
              color={ambassadors?.metaInfo?.hasNextPage ? "#1A73E8" : "#5F6368"}
            />
          </ActionIcon>
        </Group>
      </Flex>

      <Flex gap="md">
        <form onSubmit={handleSearch}>
          <TextInput
            onChange={(event) => {
              const value = event.currentTarget.value;
              if (value === "") {
                actions.ambassadors.setSearch("");
                actions.ambassadors.setPage(1);
                refetchAmbassadors();
              }
            }}
            ref={searchRef}
            radius="md"
            size="md"
            styles={{
              input: {
                fontSize: 12,
                lineHeight: "14.1px",
                color: "#70757A",
              },
            }}
            placeholder="Search"
            rightSection={
              <ActionIcon
                id="search-ambassador-button"
                type="submit"
                loading={isFetchingList}
                style={{ border: "0px solid #D2D2D2" }}
              >
                <IconSearch size={14} />
              </ActionIcon>
            }
          />
        </form>
        <SegmentedControl
          size="xs"
          value={_mode}
          onChange={(value) => {
            actions.ambassadors.setMode(value as any);
          }}
          classNames={
            {
              // label: "view-switcher",
            }
          }
          styles={{
            root: {
              gap: 10,
            },
            label: {
              height: "100%",
              display: "flex",
              alignItems: "center",
            },
          }}
          color="blue"
          data={[
            { label: <IconLayoutGrid />, value: "grid" },
            { label: <IconList />, value: "list" },
          ]}
        />
      </Flex>
    </Flex>
  );
};
